export default __webpack_public_path__ + "static/media/n_off.36da8ba6.svg";